export default __webpack_public_path__ + "static/media/fridge2-beforeA-480w.a2908f13.png";